import { TeaserType } from '../../domain/teaser/TeaserType.ts';
import TrackingService from './TrackingService.ts';
import { Topic } from './Topic.ts';

export type UpHomeTrackType = {
	up_Promo: string;
	up_TeaserType: TeaserType;
	up_TeaserSize: string;
}

export const trackClick = (trackingService: TrackingService, payload: UpHomeTrackType)=>  {
	return trackingService.sendEvent(Topic.SubmitEvent, {
		'up_Promo': [payload.up_Promo],
		'up_TeaserType': [payload.up_TeaserType],
		'up_TeaserSize': [payload.up_TeaserSize]
	});
};

export const trackView = (trackingService: TrackingService, payload: UpHomeTrackType)=>  {
	return trackingService.sendEvent(Topic.MergeEvent, {
		'up_Promo': [payload.up_Promo],
		'up_TeaserType': [payload.up_TeaserType],
		'up_TeaserSize': [payload.up_TeaserSize]
	});
};

export const trackSeen = (trackingService: TrackingService, payload: UpHomeTrackType)=>  {
	return trackingService.sendEvent(Topic.SubmitEvent, {
		'up_Promo': [payload.up_Promo],
		'up_TeaserType': [payload.up_TeaserType],
		'up_TeaserSize': [payload.up_TeaserSize]
	});
};

